import supHttps from '../init/supHttps';

//SUP-ADM-01 get list of offers
export async function listOffers(limit, offset, expiry) {
    const result = await supHttps.get(`/support/admin/list/offer?limit=${limit}&offset=${offset}&expiry=${expiry}`);
    return result;
}

//SUP-ADM-02 : Get list of all the trips that to be approved
export async function getListOfApprovals(limit, offset, type) {
    const approvals = await supHttps.get(`/support/admin/list/approval/${type}?limit=${limit}&offset=${offset}`);
    return approvals;
}

//SUP-ADM-03 : Get details of inactive trip
export async function listInactiveTrip(type, packId, limit, offset) {
    const result = await supHttps.get(`/support/admin/details/${type}/${packId}?limit=${limit}&offset=${offset}`);
    return result;
}

//SUP-ADM-04 : Approve trip
export async function approveTrip(type, packId) {
    const result = await supHttps.patch(`/support/admin/approve/${type}/${packId}`);
    return result;
}

//SUP-ADM-05 : Get all the dropdowns
export async function supportDropdown(limit, offset, type, status) {
    const dropdowns = await supHttps.get(
        `/support/admin/list/dropdowns/${type}?limit=${limit}&offset=${offset}&status=${status}`
    );
    return dropdowns;
}

//SUP-ADM-06 : To get Faq list
export async function getFaqLIstFun(type, limit, offset) {
    const result = await supHttps.get(`/support/admin/list/faq/${type}?limit=${limit}&offset=${offset}`);
    return result;
}

//SUP-ADM-07 : Reject trip
export async function rejectTrip(type, packId, data) {
    const result = await supHttps.patch(`/support/admin/reject/${type}/${packId}`, data);
    return result;
}

//SUP-ADM-08 : Get all the dropdowns
export async function supportFilter(limit, offset, type, status) {
    const filters = await supHttps.get(
        `/support/admin/list/filter/${type}?limit=${limit}&offset=${offset}&status=${status}`
    );
    return filters;
}

//SUP-ADM-09 : Offer count
export async function supOfferCount(status) {
    const result = await supHttps.get(`/support/admin/count/offer?expiry=${status}`);
    return result;
}

//SUP-ADM-10 : Count of to be approved trips
export async function supTripApprovalCount(type) {
    const result = await supHttps.get(`/support/admin/count/apprvoal/${type}`);
    return result;
}

//SUP-ADM-11 : Dropdown count
export async function supDropdownCount(type) {
    const result = await supHttps.get(`/support/admin/count/dropdown/${type}`);
    return result;
}

//SUP-ADM-12 : Faq count
export async function supFaqCount(type) {
    const result = await supHttps.get(`/support/admin/count/faq/${type}`);
    return result;
}

//SUP-ADM-13 : Filter count
export async function supFilterCount() {
    const result = await supHttps.get(`/support/admin/count/filter`);
    return result;
}

//SUP-ADM-14 : Support ticket list for admin
export async function supAdminTicket(type, status, assignedTo, createdBy) {
    const result = await supHttps.get(
        `/support/admin/ticket/list/${type}?status=${status}&assignedto=${assignedTo}&createdBy=${createdBy}`
    );
    return result;
}

//SUP-ADM-15 : Support ticket count for admin
export async function supAdminTicketCount(type, status, assignedTo, createdBy) {
    const result = await supHttps.get(
        `/support/admin/count/ticket/${type}?status=${status}&assignedto=${assignedTo}&createdBy=${createdBy}`
    );
    return result;
}

//SUP-ADM-16 : Support user list
export async function supUserList() {
    const result = await supHttps.get(`/support/admin/support/user/list`);
    return result;
}

//SUP-ADM-17 : Assign ticket
export async function supAssignTicket(type, ticketId, data) {
    const result = await supHttps.patch(`/support/admin/assign/ticket/${type}/${ticketId}`, data);
    return result;
}

//SUP-ADM-18 : Organizer list
export async function orgList(type) {
    const result = await supHttps.get(`/support/admin/org/list?type=${type}`);
    return result;
}

//SUP-ADM-19 : Organizer Dashboard
export async function orgDashboard(orgId, date, limit, offset, bookingsOnly) {
    const result = await supHttps.get(
        `/support/admin/org/dashboard/${orgId}?date=${date}&bookingsOnly=${bookingsOnly}&limit=${limit}&offset=${offset}`
    );
    return result;
}

//SUP-ADM-20 : Organizer My packages
export async function orgPackages(
    orgId,
    status,
    limit = '',
    offset = '',
    datesType = '',
    group = '',
    type = '',
    search = ''
) {
    const result = await supHttps.get(
        `/support/admin/org/my-package/${orgId}?limit=${limit}&offset=${offset}&status=${status}&datestype=${datesType}&group=${group}&type=${type}&search=${search}`
    );

    return result;
}

//SUP-ADM-21 : Organizer Billing
export async function orgBilling(orgId, status, approval, limit, offset, type) {
    const result = await supHttps.get(
        `/support/admin/org/billing/${orgId}?limit=${limit}&offset=${offset}&status=${status}&approval=${approval}&type=${type}`
    );
    return result;
}

//SUP-ADM-22 : Organizer Payouts
export async function orgPayouts(orgId, limit, offset, type) {
    const result = await supHttps.get(
        `/support/admin/org/payout/${orgId}?limit=${limit}&offset=${offset}&type=${type}`
    );
    return result;
}

//SUP-ADM-23 : Organizer Bookings
export async function orgBookings(
    orgId,
    date,
    limit = 10,
    offset = 0,
    packageId = '',
    packDateid = '',
    datesType = '',
    type = 'trip',
    group = ''
) {
    const params = new URLSearchParams();

    params.set('date', date);
    params.set('limit', limit);
    params.set('offset', offset);
    params.set('type', type);

    if (orgId) {
        params.set('orgid', orgId);
    }

    // -----------------------------------------
    // Service-specific package ID
    // -----------------------------------------

    if (packageId) {
        const idParam = {
            trip: 'packid',
            gu: 'tourid',
            act: 'actid',
            camp: 'campid'
        }[type];

        if (idParam) {
            params.set(idParam, packageId);
        }
    }

    // -----------------------------------------
    // Trip-only filters
    // -----------------------------------------

    if (type === 'trip') {
        if (packDateid) {
            params.set('packdateid', packDateid);
        }

        if (datesType) {
            params.set('datestype', datesType);
        }

        if (group) {
            params.set('group', group);
        }
    }

    return await supHttps.get(`/support/admin/org/booking?${params.toString()}`);
}

//SUP-ADM-24 : Organizer each trip date booking details
export async function orgDateDetails(orgId, packDateId) {
    const result = await supHttps.get(`/support/admin/org/date/details/${orgId}?packdate=${packDateId}`);
    return result;
}

//SUP-ADM-25 : Organizer dashboard count
export async function orgDashboardCount(orgId, date) {
    const result = await supHttps.get(`/support/admin/org/count/dashboard/${orgId}?date=${date}`);
    return result;
}

//SUP-ADM-26 : Organizer My packages Count
export async function orgPackagesCount(orgId, status, datesType, group, type, search) {
    const result = await supHttps.get(
        `/support/admin/org/count/my-package/${orgId}?status=${status}&datestype=${datesType}&group=${group}&type=${type}&search=${search}`
    );
    return result;
}
//SUP-ADM-27 : Organizer Billing Count
export async function orgBillingCount(orgId, status, approval, type) {
    const result = await supHttps.get(
        `/support/admin/org/count/billing/${orgId}?status=${status}&approval=${approval}&type=${type}`
    );
    return result;
}

//SUP-ADM-28 : Organizer Payouts Count
export async function orgPayoutsCount(orgId, type) {
    const result = await supHttps.get(`/support/admin/org/count/payout/${orgId}?type=${type}`);
    return result;
}

//SUP-ADM-29 : Organizer Bookings Count
export async function orgBookingsCount(orgid, packid, packDateid, date, datesType, group, type) {
    const result = await supHttps.get(
        `/support/admin/org/count/booking?orgid=${orgid}&date=${date}&packid=${packid}&packDatiId=${packDateid}&datestype=${datesType}&group=${group}&type=${type}`
    );
    return result;
}

//SUP-ADM-30 : Trip details
export async function supOrgTripDetailsFun(packId, type) {
    const result = await supHttps.get(`/support/admin/org/pack/${packId}?type=${type}`);
    return result;
}

// SUP-ADM-31 Trip date details
export async function supTripOrgDateFun(packId, type, datesType, offset = 0, limit = 10) {
    const result = await supHttps.get(`/support/admin/org/date/${packId}`, {
        params: {
            type,
            date: datesType,
            offset,
            limit
        }
    });

    return result;
}

//SUP-ADM-32 Dashboard stats
export async function supOrgTripDashStats(orgid, type) {
    const result = await supHttps.get(`/support/admin/org/stats/dashboard/${orgid}?type=${type}`);
    return result;
}

//SUP-ADM-33 Create trip
export async function supTripCreateFun(type, data) {
    const result = await supHttps.post(`/support/admin/org/create?type=${type}`, data);
    return result;
}

//SUP-ADM-34 Edit trip when its active
export async function supTripEdit(type, data) {
    const result = await supHttps.patch(`/support/admin/org/edit?type=${type}`, data);
    return result;
}

//SUP-ADM-35 Add date to trip
export async function supTripDateCreateFun(data) {
    const result = await supHttps.post(`/support/admin/org/create/date`, data);
    return result;
}

//SUP-ADM-36 Add unavailable dates
export async function unavailableDateFun(type, option, data) {
    const result = await supHttps.patch(`/support/admin/org/custom/add/unavai/date/${type}?option=${option}`, data);
    return result;
}

//SUP-ADM-37 Cancel the whole trip organizer
export async function supOrgTripCancelFun(data) {
    const result = await supHttps.patch(`/support/admin/org/cancel/trip`, data);
    return result;
}

//SUP-ADM-38 Cancel each booking
export async function supBookingCancelFun(data) {
    const result = await supHttps.patch(`/support/admin/org/cancel/each/booking`, data);
    return result;
}

//SUP-ADM-39 Stop auto review msg for particular date trip
export async function stopReviewFun(data) {
    const result = await supHttps.patch(`/support/admin/org/trip-date/review/msg`, data);
    return result;
}

//SUP-ADM-41 Send messages to participants of a trip
export async function supSendMsgFun(data) {
    const result = await supHttps.post(`/support/admin/org/send/msg`, data);
    return result;
}
//SUP-ADM-42 Organizer account details edit
export async function supOrgAccEditFun(data) {
    const result = await supHttps.patch('/support/admin/org/account/edit', data);
    return result;
}

//SUP-ADM-43 edit slots and rooms
export async function supTripDateEdit(status, data) {
    const result = await supHttps.patch(`/support/admin/org/edit/slots?status=${status}`, data);
    return result;
}
//SUP-ADM-44 Organizer account details
export async function supOrgAccDetailsFun(type, orgId) {
    const result = await supHttps.get(`/support/admin/org/account/details/${type}/${orgId}`);
    return result;
}

// SUP-ADM-45 Add booking manual
export async function supOrgMnBookingFun(data) {
    const result = await supHttps.post('/support/admin/org/add/manual', data);
    return result;
}

//SUP-ADM-46 Delete Trip or inactive
export async function supOrgTripDelFun(type, packid) {
    const result = await supHttps.delete(`/support/admin/org/delete/comp/${type}/${packid}`);
    return result;
}

//SUP-ADM-47 Delete date trip
export async function supOrgTripDateDelFun(dateid) {
    const result = await supHttps.delete(`/support/admin/org/delete/date/${dateid}`);
    return result;
}

//SUP-ADM-48 Custom trip particular trip, date bookings
export async function supCustomTripBookingFuc(type, packid, date) {
    const result = await supHttps.get(`/support/admin/org/custom/${type}/bookings/${packid}/${date}`);
    return result;
}

// SUP-ADM-49 Custom trip add manual
export async function supOrgCustomTripMnBookingFn(data) {
    const result = await supHttps.post(`/support/admin/org/custom/trip/manual/add`, data);
    return result;
}

// SUP-ADM-50 Details of the trip payout for payout pop-up
export async function supOrgPayoutDetails(payoutId, type) {
    const result = await supHttps.get(`/support/admin/org/payout/details/${payoutId}?type=${type}`);
    return result;
}

// SUP-ADM-51 Booking details from booking id
export async function supBookingDetails(type, bookingId) {
    const result = await supHttps.get(`/support/admin/org/booking/each/${type}/${bookingId}`);
    return result;
}

//SUP-ADM-52 Change booking
export async function supBookingUpdate(type, bookingId, data) {
    const result = await supHttps.post(`/support/admin/org/booking/change/${type}/${bookingId}`, data);
    return result;
}

// SUP-ADM-53 Status change
export async function supBookingStatusChange(data) {
    const result = await supHttps.post(`/support/admin/org/status/change`, data);
    return result;
}

//SUP-ADM-54 Support admin adds a rating/review on behalf of a user
export async function supUserReview(type, data) {
    const review = await supHttps.post(`/support/admin/user/rating/${type}`, data);
    return review;
}

// SUP-ADM-55 Add booking manual activity
export async function supOrgMnActBookingFun(data) {
    const result = await supHttps.post('/support/admin/org/act/add/manual', data);
    return result;
}

// SUP-ADM-56 Add booking manual guide
export async function supOrgMnGuBookingFun(data) {
    const result = await supHttps.post('/support/admin/org/gu/add/manual', data);
    return result;
}

//SUP-ADM-57 Get list of chatbot users
export async function supChatBotUsersFun(params) {
    const result = await supHttps.get(`/support/admin/chatbot/users`, {
        params
    });
    return result;
}

//SUP-ADM-57b Chatbot conversion report
export async function supChatBotReportFun(params) {
    return await supHttps.get('/support/admin/chatbot/report', { params });
}

//SUP-ADM-57c Website activity + lead score of a chat lead (from chatbot ?ref= links)
export async function supChatBotLeadActivityFun(id) {
    return await supHttps.get(`/support/admin/chatbot/lead/${id}/activity`);
}

//SUP-ADM-58 Add a comment to a chatbot user
export async function supChatBotaddCommentFun(data) {
    const result = await supHttps.post('/support/admin/chatbot/add/comment', data);
    return result;
}

//SUP-ADM-59 Send a chatbot message to one user
export async function supChatBotSendMessage(data) {
    const result = await supHttps.post('/chatbot/send/message', data);
    return result;
}

//SUP-ADM-60 Broadcast a chatbot message to all users
export async function supChatBotSendMessageAll(data) {
    const result = await supHttps.post('/chatbot/send/message/all', data);
    return result;
}

//SUP-ADM-61 Get app user statistics
export async function supAppUserStats(data) {
    const result = await supHttps.get('/support/admin/app/users/stats', data);
    return result;
}

//SUP-ADM-62 Send a push notification to app users
export async function supSendNotification(data) {
    const result = await supHttps.post('/support/admin/send-app-notification', data);
    return result;
}

//SUP-ADM-63 Get history of sent notifications
export async function supNotificationHistory(params) {
    const result = await supHttps.get('/support/admin/notification/history', {
        params
    });

    return result;
}

//SUP-ADM-64 Get paginated chatbot message history for a user
export async function supChatbotMessages(id, beforeId = null, limit = 10) {
    const { data } = await supHttps.get(`/support/admin/messages/${id}`, {
        params: {
            beforeId,
            limit
        }
    });

    return data;
}

//SUP-ADM-65 Add a new chatbot user
export async function supAddChatbotUser(data) {
    const result = await supHttps.post(`/support/admin/chatbot/add/user`, data);
    return result;
}

//SUP-ADM-66 Update a chatbot user's details
export async function supChatbotUserUpdate(id, data) {
    const result = await supHttps.patch(`/support/admin/chatbot/user/update/${id}`, data);
    return result;
}

//SUP-ADM-67 Get list of tracked search keywords
export async function supSearchKeywords(params) {
    const result = await supHttps.get(`/support/admin/search-keywords`, {
        params
    });
    return result;
}

//SUP-ADM-68 Delete a tracked search keyword
export async function supDelSearchKeywords(id, params) {
    const result = await supHttps.delete(`/support/admin/search-keywords/${id}`, {
        params
    });
    return result;
}

//SUP-ADM-69 Add a new tracked search keyword
export async function supAddSearchKeywords(data) {
    const result = await supHttps.post(`/support/admin/search-keywords`, data);
    return result;
}

//SUP-ADM-70 Get chatbot configuration/data entries
export async function supGetChatBotData(params) {
    return await supHttps.get('/support/admin/chatbot-data', { params });
}

//SUP-ADM-71 Create a new chatbot data entry
export async function supCreateChatBotData(data) {
    return await supHttps.post('/support/admin/chatbot-data', data);
}

//SUP-ADM-72 Update a chatbot data entry
export async function supUpdateChatBotData(id, data) {
    return await supHttps.put(`/support/admin/chatbot-data/${id}`, data);
}

//SUP-ADM-73 Delete a chatbot data entry
export async function supDeleteChatBotData(id) {
    return await supHttps.delete(`/support/admin/chatbot-data/${id}`);
}

//SUP-ADM-74 Add a new time slot to an organizer's date (support admin)
export async function supAddTimeSlot(id, type, data) {
    return await supHttps.post(`support/admin/org/${type}/date/${id}`, data);
}

//SUP-ADM-75 Edit an organizer's slot (support admin)
export async function supUpdateActivitySlot(dateId, type, slotId, data) {
    return await supHttps.patch(`/support/admin/org/${type}/date/${dateId}/slot/${slotId}`, data);
}

//SUP-ADM-76 Delete an organizer's slot (support admin)
export async function supDeleteActivitySlot(dateId, type, slotId) {
    return await supHttps.delete(`/support/admin/org/${type}/date/${dateId}/slot/${slotId}`);
}

//SUP-ADM-77 Delete an organizer's date (support admin)
export async function supDeleteActivityDate(dateId, type) {
    return await supHttps.delete(`/support/admin/org/${type}/delete/date/${dateId}`);
}

//SUP-ADM-78 Organizer dashboard data by service type (support admin)
export async function supOrgDashboardData(type, orgId, date, bookingsOnly, limit, offset) {
    return await supHttps.get(
        `support/admin/org/dashboard/${type}/${orgId}?date=${date}&bookingsOnly=${bookingsOnly}&limit=${limit}&offset=${offset}`
    );
}

//SUP-ADM-79 List of bookings for a particular organizer slot (support admin)
export async function supOrgDashboardSlotBookings(type, orgId, datesId, slotId) {
    return await supHttps.get(`support/admin/org/dashboard/${type}/${orgId}/${datesId}/${slotId}/bookings`);
}

//SUP-ADM-80 Cancel a single activity/guide/camp booking (support admin)
// camp: full refund of what was paid + rooms back on sale
export async function supOrgCancelActGuBookings(type, data) {
    return await supHttps.post(`support/admin/org/${type}/cancel/each/booking`, data);
}

//SUP-ADM-80b Add a camp / stay booking by hand (phone / walk-in guest)
// data: { listingId, checkIn, checkOut, adults, children, pets, items: [{ unitId, rooms }],
//         leadGuest: { name, phoneNumber, emailId }, amountCollected, specialRequests }
export async function supStayManualBookingFun(data) {
    return await supHttps.post('support/admin/org/camp/add/manual', data);
}

//SUP-ADM-81 Get list of app versions
export async function supAppGetVersions(params) {
    return await supHttps.get('/support/admin/app-versions', {
        params
    });
}

//SUP-ADM-82 Update an app version entry
export async function supAppUpdateVersion(id, data) {
    return await supHttps.put(`/support/admin/app-version/${id}`, data);
}

//SUP-ADM-83 Add a new app version entry
export async function supAppAddVersion(data) {
    return await supHttps.post(`/support/admin/app-version`, data);
}

//SUP-ADM-84 Backfill trip IDs for existing chatbot records
export async function supBackfillChatBotTripIds() {
    return await supHttps.post('/support/admin/chatbot/backfill-trip-ids');
}

// ── Staff Calls (Trvto Calls app) ─────────────────────────────────────────
// SUP-CALLS-01 : list staff calls (admins: everyone; others: own)
export async function listStaffCalls(params) {
    const q = new URLSearchParams(params).toString();
    return await supHttps.get(`/support/calls/admin/list?${q}`);
}

// SUP-CALLS-02 : staff list for the filter dropdown
export async function listCallStaff() {
    return await supHttps.get(`/support/calls/admin/staff`);
}

// SUP-CALLS-03 : fetch one recording as a blob (adds the auth header)
export async function fetchCallRecording(callId) {
    return await supHttps.get(`/support/calls/${callId}/recording`, { responseType: 'blob' });
}

// SUP-CALLS-04 : save notes / outcome / follow-up for a call
export async function updateStaffCall(callId, body) {
    return await supHttps.patch(`/support/calls/${callId}`, body);
}

// SUP-CALLS-05 : staff call history for a lead's phone number
export async function getLeadCalls(number) {
    return await supHttps.get(`/support/calls/leads/by-number/${encodeURIComponent(number)}`);
}

// SUP-CALLS-06 : agent starts logging a call to a lead (by chatId)
export async function startWebCall(chatId) {
    return await supHttps.post(`/support/calls/web/start`, { chatId });
}

// SUP-CALLS-07 : agent ends the call (notes / outcome; schedules confirmation)
export async function endWebCall(callId, body) {
    return await supHttps.post(`/support/calls/web/${callId}/end`, body);
}

// SUP-CALLS-08 : cancel a live call started by mistake
export async function cancelWebCall(callId) {
    return await supHttps.post(`/support/calls/web/${callId}/cancel`);
}

// ── Chatbot Q&A / Auto-replies ──────────────────────────
export async function supGetChatBotFaq({ search = '', active = '', page = 1, limit = 20 } = {}) {
    const q = new URLSearchParams({ search, active, page, limit }).toString();
    return await supHttps.get(`/support/admin/chatbot-faq?${q}`);
}
export async function supCreateChatBotFaq(body) {
    return await supHttps.post(`/support/admin/chatbot-faq`, body);
}
export async function supUpdateChatBotFaq(id, body) {
    return await supHttps.put(`/support/admin/chatbot-faq/${id}`, body);
}
export async function supDeleteChatBotFaq(id) {
    return await supHttps.delete(`/support/admin/chatbot-faq/${id}`);
}
export async function supTestChatBotFaq(message) {
    return await supHttps.post(`/support/admin/chatbot-faq/test`, { message });
}
